"use strict";var m=Object.defineProperty;var v=Object.getOwnPropertyDescriptor;var r=(p,c,t,s)=>{for(var o=s>1?void 0:s?v(c,t):c,a=p.length-1,l;a>=0;a--)(l=p[a])&&(o=(s?l(c,t,o):l(o))||o);return s&&o&&m(c,t,o),o};import{baseStyles as g,CiscoUElement as _,html as e,nothing as i}from"@cisco-u/base";import"@cisco-u/icons/icons/cu-icon-briefcase.js";import"@cisco-u/icons/icons/cu-icon-certification.js";import"@cisco-u/icons/icons/cu-icon-cisco-u.js";import"@cisco-u/icons/icons/cu-icon-cisco-u-pulse.js";import"@cisco-u/icons/icons/cu-icon-close-x.js";import"@cisco-u/icons/icons/cu-icon-color-rounded.js";import"@cisco-u/icons/icons/cu-icon-color-stars.js";import"@cisco-u/icons/icons/cu-icon-curved-rectangle.js";import"@cisco-u/icons/icons/cu-icon-dodeca-star.js";import"@cisco-u/icons/icons/cu-icon-leaf.js";import"@cisco-u/icons/icons/cu-icon-rounded-play.js";import"@cisco-u/icons/icons/cu-icon-rounded-rectangle.js";import"@cisco-u/icons/icons/cu-icon-rounded-star.js";import"@cisco-u/icons/icons/cu-icon-semicircle.js";import"@cisco-u/icons/icons/cu-icon-spiked-circle.js";import"@cisco-u/icons/icons/cu-icon-widget.js";import"@cisco-u/bookmark/cu-bookmark.js";import"@cisco-u/button/cu-button.js";import"@cisco-u/tooltip/cu-tooltip.js";import"@cisco-u/icons/icons/cu-icon-check-thick.js";import"@cisco-u/icons/icons/cu-icon-locked.js";import"@cisco-u/progress-bar/cu-progress-bar.js";import{property as n,query as d,queryAsync as b,state as u}from"@cisco-u/base/src/decorators.js";import y from"./assets/sale-tag.js";import{cardType as $}from"./assets/type.js";import{returnVendorLogo as f}from"./assets/vendor-return.js";import k from"./new-card.css.js";export class NewCard extends _{constructor(){super(...arguments);this.currency="$";this.currencypos="start";this._showRemove=!1}willUpdate(t){t.has("price")&&(typeof this.price=="string"||typeof this.price=="number")&&(this.price=this._convertPrice(this.price)),t.has("listprice")&&(typeof this.listprice=="string"||typeof this.listprice=="number")&&(this.listprice=this._convertPrice(this.listprice))}_convertPrice(t){t=`${t}`;const s=/[,.](?=[^,.]*$)/,o=t==null?void 0:t.match(s),a=t==null?void 0:t.split(s),l=a==null?void 0:a.shift();let h;return a!=null&&a.length&&(h=e`<span class="cents"
        >${o}${a.shift()}</span
      >`),e`${l}${h}`}static get styles(){return[g,k]}render(){return e`<article class="card-wrap">
      ${this.link?e`<a
            href=${this.link}
            class="card"
            target=${this._newTab()}
            @click=${this._dispatchCardClick}
            >${this._buildCardEle()}</a
          >`:e`<button class="card" @click=${this._dispatchCardClick}>
            ${this._buildCardEle()}
          </button>`}
      <div class="footer">
        ${(this.price||this.credits)&&this._returnFooterPricing()}
        ${this.premium&&!this.price&&!this.credits?e`<div class="buying-options">
              <cu-icon-locked></cu-icon-locked> View subscription options
            </div>`:i}
        ${!(this.premium||this.price||this.credits)&&this.progress?this._returnProgress():i}

        <div class="actions">
          <slot name="actions"></slot>
          ${this.removable&&!this.admin?this._returnRemoveItem():i}
          ${this.removable&&this.admin?this._returnAdminRemove():i}
          ${this.noBookmark?i:this._returnBookmark()}
        </div>
      </div>
    </article>`}_newTab(){return this.newTab?"_blank":i}_activeClassBookmarked(){return this.bookmarked?"active":""}_returnAdminRemove(){return e`<div class="remove">
      <button
        @click=${this._handleAdminPop}
        class="popover-btn${this._showRemove?" visible":""}"
      >
        <cu-icon-close-x size="s"></cu-icon-close-x>
      </button>
      <div class="admin-tooltip"><slot name="admin-tooltip"></slot></div>
    </div>`}_returnRemoveItem(){return e`<div class="remove">
      <cu-tooltip text="Remove from My Learning" position="top">
        <button
          @click=${this._handlePopover}
          class="popover-btn${this._showRemove?" visible":""}"
        >
          <cu-icon-close-x size="s"></cu-icon-close-x>
        </button>
      </cu-tooltip>
      ${this._showRemove?e`<div class="popover">
            <div class="popover-text">Remove from My Learning?</div>
            <div class="popover-btns">
              <cu-button
                @click=${()=>this._showRemove=!this._showRemove}
                template="secondary"
                size="s"
                class="cancel-remove"
                tabindex="-1"
                >Cancel</cu-button
              >
              <cu-button
                @click=${this._dispatchRemove}
                template="primary"
                size="s"
                class="remove-btn"
                >Yes, remove</cu-button
              >
            </div>
          </div>`:i}
    </div>`}_handleAdminPop(){this._showRemove=!this._showRemove,this._adminPopEle.classList.toggle("show")}_handlePopover(){this._showRemove=!this._showRemove,this._cancelRemove.then(t=>{t.focus()})}_returnBookmark(){return e`<cu-bookmark
      @click=${this._dispatchBookmark}
      label="Bookmark ${this._cardTitle}"
      class=${this._activeClassBookmarked()}
    ></cu-bookmark>`}_buildCardEle(){return e`
      <div class="body">
        <div class="header">
          ${$(this)} ${this.list?this._returnTags():i}
          ${this.saletext?i:f(this)}
        </div>
        <div class="info">
          <h3 class="heading">
            <slot name="heading" @slotchange=${this._setCardTitle}></slot>
          </h3>
          ${this.list||this.author?this._returnDescription():i}
        </div>
        ${this.list?i:this._returnTags()}
        ${this.list?i:this._returnJobRoles()}
        <div class="details">
          <div class="date-garden">
            ${this.date?this._returnDate():i}
            <div class="garden"><slot name="garden"></slot></div>
          </div>
          ${this._returnRelatedSection()}
        </div>
      </div>
      ${this.saletext?this._returnSaletag():i}
    `}_returnSaletag(){return e`<div class="sale-tag">
      <img src=${y} alt="" /><span class="sale-text"
        >${this.saletext} <span>OFF</span></span
      >
    </div>`}_setCardTitle(t){t.target&&(this._cardTitle=t.target.assignedElements({flatten:!0})[0].textContent.trim())}_returnDescription(){return e`<div class="description">
      ${this.author?e`<div class="author">By ${this.author}</div>`:i}
      ${this.list?e`<slot name="description"></slot>`:i}
    </div>`}_returnTags(){return e`<div class="tags hide">
      <slot name="tags" @slotchange=${this._displaySlot}></slot>
    </div>`}_returnDate(){var o;const t=(o=this.date)==null?void 0:o.trim(),s=t==null?void 0:t.split(" ");return s==null?i:e`<div class="date">
      <span class="month">${s[0]}</span>
      <span class="day">${s[1]}</span>
    </div>`}_returnRelatedSection(){return e`
      <div class="jobs-related">
        ${this.list?this._returnJobRoles():i}
        ${this._returnRelatedCerts()}
        ${this.list?this._returnRelatedSkills():i}
      </div>
    `}_returnRelatedCerts(){return e`<div class="related hide">
      <cu-icon-certification></cu-icon-certification>
      <span class="related-text">Certfications:</span>
      <slot name="related-certs" @slotchange=${this._displaySlot}></slot>
    </div>`}_returnRelatedSkills(){return e`<div class="related hide">
      <cu-icon-technical-skills></cu-icon-technical-skills>
      <span class="related-text">Skills:</span>
      <slot name="related-skills" @slotchange=${this._displaySlot}></slot>
    </div>`}_displaySlot(t){var o;(o=t.target.parentElement)==null||o.classList.remove("hide")}_returnJobRoles(){var s;const t=this.list?this._jobRoles:(s=this._jobRoles)==null?void 0:s.split(",").map(o=>o.trim());return e`<div class="jobs hide">
      <cu-icon-briefcase></cu-icon-briefcase
      ><span class="jobs-text">Possible job roles:</span>
      ${this._jobRoles&&this.list?e`<div class="jobs-comma">${t}</div>`:i}
      ${this._jobRoles&&!this.list?this._returnJobsList(t):i}
      <div class="hide">
        <slot name="jobs" @slotchange=${this._updateJobs}></slot>
      </div>
    </div>`}_returnJobsList(t){return e`<ul>
      ${t==null?void 0:t.map(s=>e`<li>${s}</li>`)}
    </ul>`}_updateJobs(t){var o;const s=t.target.assignedElements({flatten:!0})[0];this._jobRoles=(o=s.textContent)!=null?o:"",t.target.parentElement.parentElement.classList.remove("hide")}_returnFooterPricing(){const t=this.listprice?this._priceReturn(this.currency,this.currencypos,this.listprice,!0):"";return e`<div class="pricing${this.credits&&" has-credits"}">
      ${this.price?e`${this._priceReturn(this.currency,this.currencypos,this.price,!1)}${t}`:i}
      ${this.credits?this._creditsReturn(this.credits):i}
      <div class="currency-type">
        <slot name="currency-type"></slot>
      </div>
    </div>`}_priceReturn(t,s,o,a){const l=e`<span class="currency"
      >${t}</span
    >`;return e`<span
      class="price${a?" list":""}"
      :aria-label=${a?i:"Price"}
      >${s!="end"?l:i}${o}${s=="end"?l:i}</span
    >`}_creditsReturn(t){return e`<span class="credits">${t}</span>`}_returnProgress(){const t=this.progress?!isNaN(this.progress):!1;return e` <div class="progress-bar">
      ${t?e`<cu-progress-bar
            progress=${this.progress}
            color="gray-0"
            height="0.5rem"
            dark="true"
            thin="true"
            barColor=${this.retired?"gray-60":i}
          ></cu-progress-bar>`:e`${this.progress} ${this._returnCheck()}`}
    </div>`}_returnCheck(){var t,s;return((t=this.progress)==null?void 0:t.toLowerCase())==="completed"||((s=this.progress)==null?void 0:s.toLowerCase())==="proficient"?e`<cu-icon-check-thick size="s"></cu-icon-check-thick>`:i}_returnCardObject(){return{type:this.type,date:this.date,vendor:this.vendor,progress:this.progress,author:this.author,premium:this.premium,list:this.list,bookmarked:this.bookmarked,title:this._cardTitle,jobRoles:this._jobRoles}}_newDispatch(t,s,o){const a={cancelable:!0,...o};return this.dispatchEvent(new CustomEvent(t,{detail:s,...a}))}_dispatchBookmark(){this.bookmarked=!this.bookmarked,this._newDispatch("cu-card-bookmark",this._returnCardObject(),null)}_dispatchRemove(t){this._newDispatch("cu-card-remove",this._returnCardObject(),null)||t.preventDefault()}_dispatchCardClick(t){this._newDispatch("cu-card",this._returnCardObject(),null)||t.preventDefault()}}r([n({type:String,reflect:!0})],NewCard.prototype,"type",2),r([n({type:String,reflect:!0})],NewCard.prototype,"date",2),r([n({type:String,reflect:!0})],NewCard.prototype,"vendor",2),r([n({type:String,reflect:!0})],NewCard.prototype,"progress",2),r([n({type:String,reflect:!0})],NewCard.prototype,"author",2),r([n({type:String,reflect:!0})],NewCard.prototype,"link",2),r([n({type:Boolean,reflect:!0})],NewCard.prototype,"premium",2),r([n({type:Boolean,reflect:!0})],NewCard.prototype,"list",2),r([n({type:Boolean,reflect:!0})],NewCard.prototype,"bookmarked",2),r([n({type:Boolean,reflect:!0})],NewCard.prototype,"noBookmark",2),r([n({type:Boolean,reflect:!0})],NewCard.prototype,"newTab",2),r([n({type:Boolean,reflect:!0})],NewCard.prototype,"removable",2),r([n({type:Boolean,reflect:!0})],NewCard.prototype,"admin",2),r([n({type:Boolean,reflect:!0})],NewCard.prototype,"retired",2),r([n({type:String,reflect:!0})],NewCard.prototype,"price",2),r([n({type:String,reflect:!0})],NewCard.prototype,"listprice",2),r([n({type:String,reflect:!0})],NewCard.prototype,"credits",2),r([n({type:String,reflect:!0})],NewCard.prototype,"currency",2),r([n({type:String,reflect:!0})],NewCard.prototype,"currencypos",2),r([n({type:String,reflect:!0})],NewCard.prototype,"saletext",2),r([b(".cancel-remove")],NewCard.prototype,"_cancelRemove",2),r([d(".admin-tooltip")],NewCard.prototype,"_adminPopEle",2),r([d(".footer")],NewCard.prototype,"_footer",2),r([u()],NewCard.prototype,"_cardTitle",2),r([u()],NewCard.prototype,"_jobRoles",2),r([u()],NewCard.prototype,"_showRemove",2);
//# sourceMappingURL=NewCard.js.map
